// import React from "react";
import { Star, Quote, UserCircle2Icon } from "lucide-react";

function Testimonials() {
  const testimonials = [
    {
      name: "Deekshanya",
      role: "",
      // image: "https://images.pexels.com/photos/3184317/pexels-photo-3184317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      content:
        "I had such a wonderful experience with you in the life coaching sessions. I definitely recommend people to join your sessions because you are a very cheerful and friendly person, you make sure to be there for your clients always. 'INU' is my favourite of all. You hyped me up during rough days , pushed me to be productive with beautiful affirmations and visualizations.  I loved your enthusiasm towards crafting my life and lending understanding ears.",
      rating: 5,
    },
    {
      name: "Aarti",
      // role: "",
      // image: "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      content:
        "Thank you so much maam 💖 Your words genuinely touched me, I am  grateful for your kindness and support. I am  just trying to take one step at a time, and knowing there are people like you cheering me on makes the journey feel lighter ✨. Looking forward to growing and learning alongside all of you 💫🙏",
      rating: 5,
    },
    {
      name: "Shivani",
      // role: "Teacher",
      // image:
      //   "https://images.pexels.com/photos/3184318/pexels-photo-3184318.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      content:
        "Thank u so much ma'am for ur kind  words... It means a lot to me.. U have build a confidence in me to move forward 🥰 fr a bright future. The whole experience helped me to move closer to my goals with gentle pushes acknowledgement of potential. My biggest breakthroughs happened when you offered me positive encouragement.",
      rating: 5,
    },
    {
      name: "Srishti",
      // role: "Consultant",
      // image:
      //   "https://images.pexels.com/photos/3184340/pexels-photo-3184340.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      content:
        "Thank u so much ma'am for ur kind  words... It means a lot to me.. U have build a confidence in me to move forward 🥰 fr a bright future",
      rating: 5,
    },
    {
      name: "Neha",
      // role: "Consultant",
      // image:
      //   "https://images.pexels.com/photos/3184340/pexels-photo-3184340.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      content:
        "Thank you so much dear..🥰 feeling very relaxed.. and also confident about my thoughts after talking with you.. egarly waiting for bootcamp.. your such a sweet heart 💜",
      rating: 5,
    },
    {
      name: "Ketaki",
      // role: "Consultant",
      // image:
      //   "https://images.pexels.com/photos/3184340/pexels-photo-3184340.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      content:
        "Thank you so much for your guidance and support 🙏 ❤️  .. you helped me a lot throughout this journey 🤗 ... I'm so grateful to you for being there for me and having faith on me 🩷 .. Thanks a lot 🙏 💕",
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Read testimonials from clients who have transformed their lives
            through our coaching programs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 text-yellow-400 fill-current"
                  />
                ))}
              </div>

              <Quote className="h-8 w-8 text-purple-600 mb-4 opacity-50" />

              <p className="text-gray-700 mb-6 leading-relaxed">
                {testimonial.content}
              </p>

              <div className="flex items-center">
                <UserCircle2Icon className="h-8 w-8 text-purple-600 mb-4 opacity-50" />
                <div>
                  <h4 className="font-semibold text-gray-900">
                    {testimonial.name}
                  </h4>
                  {/* <p className="text-sm text-gray-600">{testimonial.role}</p> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
